
  import {Component, Vue} from 'vue-property-decorator';
  import {IReport} from "@/modules/Report/interfaces/report.interface";
  import ReportTable from "@/modules/Report/components/ReportTable.vue";
  import {ReportPrintActions} from "@/modules/Report/mixins/print-data.mixin";
  import {IApp} from "@/interfaces/app.interface";
  import CarsTableTotal from "@/modules/Report/components/SpecialComponents/CarsTableTotal.vue";

  @Component({
    components: {
      CarsTableTotal,
      ReportTable,
    },
  })
  export default class ReportTableCars extends Vue {

    get tableList(): IReport.ICars[] { return this.$store.getters['report/sortedList'].array; }
    get dataProps(): IReport.ITableProp[] {
      return [
        { label: 'Корпорация',         prop: 'corpName',     propType: IApp.SortingPropType.String, },
        { label: 'Номер',              prop: 'carNumber',    propType: IApp.SortingPropType.String, actionClick: this.openCarPopup },
        { label: 'Владелец',           prop: 'persName',     propType: IApp.SortingPropType.String, },
        { label: 'Со скидкой',         prop: 'tsum',         propType: IApp.SortingPropType.Number, isMoney: true, },
        { label: 'Скидка',             prop: 'discountSum',  propType: IApp.SortingPropType.Number, isMoney: true, },
        { label: 'Тек. % скидки',      prop: 'calcDiscount', propType: IApp.SortingPropType.Number, },
        { label: 'Оплата',             prop: 'paySum',       propType: IApp.SortingPropType.Number, isMoney: true, },
        { label: 'Дней на парковке',   prop: 'daysCnt',      propType: IApp.SortingPropType.Number, },
        { label: 'Ср. часов в день',   prop: 'hourAvg',      propType: IApp.SortingPropType.Number, },
        { label: 'Тип оплаты',         prop: 'corpPayType',  propType: IApp.SortingPropType.String, },
        { label: 'Комментарий',        prop: 'corpTarif',    propType: IApp.SortingPropType.String, },
        { label: 'Последняя парковка', prop: 'lastSale',     propType: IApp.SortingPropType.Date, dateFormat: 'DD.MM.YYYY', mobileHide: true, },
      ];
    }
    get printedOptions() {
      return {
        $options: this.$options,
        tableList: this.tableList,
        dataProps: this.dataProps,
      };
    }

    async openCarPopup(item: IReport.ICars) {
      await this.$store.dispatch('car/openCarPopup', { carId: item.carId });
    }

    async reloadData() {
      await this.$store.dispatch('report/getReport', {
        reportName: this.$store.state.report.activeReport,
        filters: {...this.$store.state.report.filters},
      });
    }

    printTable() {
      ReportPrintActions.PrintTable(this.printedOptions);
    }

    prepareExcel() {
      return ReportPrintActions.PrepareExcel(this.printedOptions);
    }
  }
